import { EvidenceFieldRow } from 'components/tables/data/evidence-field/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the evidence field id.
 */
export default function EvidenceFieldIdColumn({ data: { evidenceFieldId } }: { data: EvidenceFieldRow }) {
  return <P3Regular color="gray.8">{evidenceFieldId}</P3Regular>;
}
